import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// Import translation files
import en from "../locales/en.json";
import ru from "../locales/ru.json";
import tg from "../locales/tg.json";
import uz from "../locales/uz.json";
import {
  detectAndApplyGeoLanguage,
  geoipDetector,
} from "../utils/geoLanguageDetector";

// Language resources
const resources = {
  en: { translation: en },
  ru: { translation: ru },
  uz: { translation: uz },
  tg: { translation: tg },
};

// Create language detector instance
const languageDetector = new LanguageDetector();
languageDetector.addDetector(geoipDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["en", "ru", "uz", "tg"],

    // Detection order - prioritize user's explicit choice, then geo, then browser
    detection: {
      order: ["localStorage", "geoipDetector", "navigator"],
      caches: ["localStorage"],
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    react: {
      useSuspense: false, // Disable suspense for SSR compatibility
    },
  });

// Async geo-detection: fetch country from Cloudflare and apply language if needed
detectAndApplyGeoLanguage(i18n);

// Keep document language attribute in sync with app language
const applyDocumentLanguage = (lng: string) => {
  if (typeof document === "undefined") return;
  document.documentElement.lang = lng || "en";
};
applyDocumentLanguage(i18n.language);
i18n.on("languageChanged", applyDocumentLanguage);

// No longer sync with Google Translate cookie - let user control language explicitly
export const syncLanguageWithGoogleTranslate = () => {
  // Disabled - user's localStorage choice takes priority
};

// Removed interval that was overriding user's language choice

export default i18n;
